<template>
    <div class="w-64">
        <label class="block text-sm font-bold mb-1 dark:text-slate-100" for="phone">
            Phone Number
        </label>
        <input
            id="phone"
            ref="phone"
            name="phone"
            class="form-input w-full"
            @input="updatePhone"
            placeholder="(###) ###-####"
            v-maska
            data-maska="(###) ###-####"
            v-model="appStore.userSettings.phone"
        />
    </div>
</template>
<script setup>
import { useAppStore } from '@/store/app';
import { vMaska } from 'maska/vue';
import { notify } from 'notiwind';

const appStore = useAppStore();
const props = defineProps({
    phone: {
        type: String,
        default: null,
    },
});
const emit = defineEmits(['updatephone']);

const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/;
    return phoneRegex.test(phone);
};

const updatePhone = (el) => {
    if (el.detail && validatePhoneNumber(el.target.value)) {
        appStore.setPhone(el.target.value);
        emit('updatephone', appStore.phone);
        ApiService.apiCall('/user/setting', 'put', {
            setting: 'phone',
            value: appStore.phone,
        })
            .then((response) => {})
            .catch((response) => {
                notify({
                    group: 'error',
                    title: 'Failed to update phone number',
                    text: 'Please try again later',
                    type: 'error',
                });
            });
    }
};
</script>
